import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Env from './util/env'

Env.getUserInfo (function (user) {
  ReactDOM.render (<App/>, document.getElementById ('root'));
})



// WEBPACK FOOTER //
// ./src/index.js